export enum AspectRatio {
    "21/9" = "21/9", // very wide
    "16/9" = "16/9", // most common
    "16/10" = "16/10", // a bit flat
    "4/3" = "4/3", // very flat
    "1/1" = "1/1", // square
}